import React, { Component } from "react";
import { isStorefrontGridEnabled } from "../Storefront/featureFlags";
import GridCategoryCard from "../Storefront/CategoryCard/GridCategoryCard";

class Category extends Component {
  render() {
    const { min_order, settings, language } = this.props;
    if (isStorefrontGridEnabled(settings)) return <GridCategoryCard {...this.props} />;
    let min_order_text = min_order
      ? language === "english"
        ? ` Min Order ${min_order} ${settings.currency_english} `
        : ` الحد الأدنى ${min_order} ${settings.currency_local} `
      : null;

    return (
      <div
        onClick={() => this.props.history.push(`/category/${this.props.slug}`)}
        className="pointer"
        style={{
          height: 164,
          width: "49.8%",
          borderRadius: 7,
          marginBottom: 3,
          background: `url(${this.props.image}) no-repeat center center`,
          backgroundSize: settings?.fit_images_to_div ? "100% 100%" : "cover",
          border: "1px solid white",
          minHeight: 240,
        }}
      >
        {!settings.hide_grid_category_name && (
          <>
            <div
              style={{
                background: "black",
                width: "100%",
                height: "100%",
                height: "240px",
                opacity: 0.3,
                position: "relative",
                textAlign: "center",
                borderRadius: 7,
                top: 0,
                left: 0,
              }}
            ></div>

            <p
              style={{
                top: -135,
                left: 0,
                position: "relative",
                zIndex: 3,
                display: "block",
                color: "white",
                fontSize: "1.4rem",
                overflowWrap: "break-word",
              }}
            >
              {this.props.name}
            </p>
          </>
        )}
      </div>
    );
  }
}

export default Category;
